import { removeCookie } from '../cookies';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface StaffSession {
    staffId: string | null;
    staffSignature: string | null;
    userId: string | null;
    logoutPending: boolean;
    pinUpgradeLogout: boolean;
}

interface StaffSessionStore extends StaffSession {
    setStaffSession: (
        session: Omit<StaffSession, 'logoutPending' | 'pinUpgradeLogout'>,
    ) => void;
    setLogoutPending: (pending: boolean) => void;
    logoutForPinUpgrade: VoidFunction;
    clearPinUpgradeLogout: VoidFunction;
    reset: VoidFunction;
}

const initialState: StaffSession = {
    staffId: null,
    staffSignature: null,
    userId: null,
    logoutPending: false,
    pinUpgradeLogout: false,
};

export const useStaffSessionStore = create(
    persist<StaffSessionStore>(
        (set) => ({
            ...initialState,
            setStaffSession: (session) => set(session),
            setLogoutPending: (pending) => set({ logoutPending: pending }),
            logoutForPinUpgrade: () =>
                set({
                    staffId: null,
                    staffSignature: null,
                    userId: null,
                    logoutPending: false,
                    pinUpgradeLogout: true,
                }),
            clearPinUpgradeLogout: () => set({ pinUpgradeLogout: false }),
            reset: () => set(initialState),
        }),
        {
            name: 'staff-session',
            storage: createJSONStorage(() => sessionStorage),
            onRehydrateStorage: () => (state) => {
                const OLD_KEYS = ['@staff_id', '@staff_signature', '@user_id'];
                OLD_KEYS.forEach((key) => {
                    removeCookie(key);
                });

                if (state?.logoutPending) {
                    sessionStorage.removeItem('staff-session');
                    queueMicrotask(() => {
                        useStaffSessionStore.getState().reset();
                    });
                }
            },
        },
    ),
);
